import React from "react";
import { isMobile } from "../../../utils/commonMethods";

const PayKasamaWallet = ({ paykasamaLink }) => {
  return (
    <iframe
      id="kassma-plugin-frame"
      src={paykasamaLink}
      style={{
        width: isMobile() ? window.innerWidth - 10 : window.innerWidth / 2,
        height: 0.7 * window.innerHeight,
        border: "0",
      }}
    ></iframe>
  );
};

export default PayKasamaWallet;
